var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              staticClass: "my-1",
              attrs: { variant: "primary" },
              on: { click: _vm.openAddModal },
            },
            [_vm._v(" Add Income ")]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addModal",
            title: _vm.isEditMode ? "Edit Income" : "Add Income",
            centered: "",
            "hide-footer": "",
          },
          model: {
            value: _vm.showAddModal,
            callback: function ($$v) {
              _vm.showAddModal = $$v
            },
            expression: "showAddModal",
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-form",
                {
                  staticClass: "p-3",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.AddIncome($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Income Date",
                                "label-for": "incomeDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "form-control-custom",
                                attrs: { id: "incomeDate", required: "" },
                                model: {
                                  value: _vm.newIncome.incomeDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newIncome, "incomeDate", $$v)
                                  },
                                  expression: "newIncome.incomeDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: { label: "Tax", "label-for": "tax" },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "form-control-custom",
                                  attrs: {
                                    id: "tax",
                                    options: _vm.taxOptions,
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.newIncome.tax,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newIncome, "tax", $$v)
                                    },
                                    expression: "newIncome.tax",
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v("Select a tax")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: { label: "Total", "label-for": "total" },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: {
                                  id: "total",
                                  type: "number",
                                  step: "0.01",
                                  required: "",
                                },
                                on: { input: _vm.calculateTaxAmount },
                                model: {
                                  value: _vm.newIncome.total,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newIncome,
                                      "total",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "newIncome.total",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Reference",
                                "label-for": "reference",
                              },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: { id: "reference", required: "" },
                                model: {
                                  value: _vm.newIncome.reference,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newIncome, "reference", $$v)
                                  },
                                  expression: "newIncome.reference",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Tax Amount",
                                "label-for": "taxAmount",
                              },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: {
                                  id: "taxAmount",
                                  readonly: "",
                                  type: "number",
                                  step: "0.01",
                                },
                                model: {
                                  value: _vm.newIncome.taxAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newIncome, "taxAmount", $$v)
                                  },
                                  expression: "newIncome.taxAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "modal-footer d-flex justify-content-center",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary w-50",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticClass: "mx-2",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(_vm.isEditMode ? "Update" : "Add") +
                              " "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "viewModal", title: "View Income", centered: "" },
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _c("p", [
            _c("strong", [_vm._v("Income Date: ")]),
            _vm._v(_vm._s(_vm.selectedIncome.incomeDate)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Reference: ")]),
            _vm._v(_vm._s(_vm.selectedIncome.reference)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Total Amount: ")]),
            _vm._v(_vm._s(_vm.selectedIncome.total)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Currency: ")]),
            _vm._v(_vm._s(_vm.selectedIncome.currency)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Tax Amount: ")]),
            _vm._v(_vm._s(_vm.selectedIncome.taxAmount)),
          ]),
        ]
      ),
      _vm.incomeList.length === 0
        ? _c("h3", { staticClass: "text-center" }, [_vm._v("No income Data")])
        : _vm._e(),
      _vm.dataLoaded
        ? _c("b-table", {
            attrs: {
              items: _vm.incomeList,
              fields: _vm.fields,
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              responsive: "",
              striped: "",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(incomeDate)",
                  fn: function (row) {
                    return [
                      _vm._v(
                        " " + _vm._s(row.item.incomeDate.split("T")[0]) + " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (row) {
                    return [
                      _c(
                        "b-dropdown",
                        {
                          attrs: {
                            variant: "link",
                            "toggle-class": "text-decoration-none",
                            "no-caret": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("feather-icon", {
                                      staticClass:
                                        "text-body align-middle mr-25",
                                      attrs: {
                                        icon: "MoreVerticalIcon",
                                        size: "16",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openViewModal(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EyeIcon" },
                              }),
                              _c("span", [_vm._v("View")]),
                            ],
                            1
                          ),
                          _c(
                            "b-dropdown-item",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.editModal",
                                  modifiers: { editModal: true },
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.openEditModal(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EditIcon" },
                              }),
                              _c("span", [_vm._v("Edit")]),
                            ],
                            1
                          ),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.confirmDelete(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "TrashIcon" },
                              }),
                              _c("span", [_vm._v("Delete")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2933808557
            ),
          })
        : _c(
            "div",
            { staticClass: "text-center p-4" },
            [
              _c("b-spinner", {
                attrs: { variant: "primary", label: "Loading income data..." },
              }),
              _c("p", [_vm._v("Loading data, please wait...")]),
            ],
            1
          ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }